/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import InputButton from '../ZUILib/InputButton';
import commonUtil from '../../utils/commonUtil';

const Modal = ({ show, goAccountPath, title, body }) => {
  const channel = commonUtil.getChannel();
  const constChannels = commonUtil.getClientConstForChannel();
  const isWap = channel === constChannels.WAP;
  const btnPrimaryClose = {
    name: 'btnPrimaryClose',
    type: 'button',
    value: 'Aceptar',
    autoFocus: false,
    classname: 'btnPrimary size-Large',
    cssStyle: {
      width: isWap ? '100%' : '60%',
      borderRadius: '4px',
      padding: isWap ? '5px' : '0',
    },
    onClickHandler: goAccountPath,
  };
  const isWapStyle = isWap ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : {};
  return (
    <React.Fragment>
      <div className="modal fade modal-custom in" style={{ display: show ? 'block' : 'none' }}>
        <div className="modal-dialog" role="document" style={isWapStyle}>
          <div style={{ borderRadius: '4px', backgroundColor: '#ffffff', width: '85%' }}>
            <div className="modal-body" style={{ padding: '0' }}>
              <div
                style={{
                  padding: '18px',
                  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.15)',
                  fontSize: '18px',
                }}
              >
                { title || '¡Ocurrió un error!' }
                <button
                  onClick={goAccountPath}
                  className="close error-modal-close"
                  type="button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                      fill="#333333"
                    />
                  </svg>
                </button>
              </div>
              <div style={{ display: 'flex', padding: '2rem 3rem', flexDirection: 'column', alignItems: 'center' }}>
                <p style={{ fontSize: '16px' }}>
                  { body ? <p dangerouslySetInnerHTML={{ __html: body }} /> : '¡Lo sentimos! Ha ocurrido un error' }
                </p>
                <InputButton buttonAttr={btnPrimaryClose} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade in" />}
    </React.Fragment>
  );
};

class ErrorModal extends Component {
  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      show: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleShow(errorMessage) { 
    this.setState({ 
      show: true,
      ...(errorMessage && {errorMessage: errorMessage})
    }); 
  }

  handleClose = async () => { this.setState({ show: false }); }

  goAccountPath = async () => {
    const applicationRoutes = commonUtil.getApplicationRoutes();
    await this.handleClose();
    this.props.setGiftListTransferenceStatementTab(true);
    browserHistory.push(
      commonUtil.routeTo(applicationRoutes.giftList,
      { eventID: this.props.eventId },
    ));
  }

  render() {
    return (
      <Modal
        show={this.state.show}
        goAccountPath={this.goAccountPath}
        title={this.props.titleError}
        body={this.props.bodyError || this.state.errorMessage}
      />
    );
  }
}

export default ErrorModal;
